const documentClickHandlers = [
  {
    selector: '.nav-burger-toggle:not(.nav-burger-toggle--close)',
    handler() {
      document.querySelector('.nav-burger')?.classList.add('is-open');
    },
  },
  {
    selector: '.nav-burger-toggle--close',
    handler() {
      document.querySelector('.nav-burger')?.classList.remove('is-open');
    },
  },
  {
    selector: '.solutions__tabs .tabs__toggle',
    handler(tab) {
      tab
        .closest('.tabs')
        .querySelector('.solutions-tab')
        .classList.remove('is-active');
      for (const sibling of tab.parentNode.children) {
        sibling.classList.remove('is-selected');
      }
      tab.classList.add('is-selected');
      const targetTab = document.querySelector(tab.dataset.targetTab);
      if (targetTab === null) {
        return;
      }
      for (const siblingTabs of targetTab.parentNode.children) {
        siblingTabs.classList.remove('is-active');
      }
      targetTab.classList.add('is-active');
    },
  },
  {
    selector: '.accordion-item__toggle',
    handler(element) {
      element.classList.toggle('is-open');
    },
  },
  {
    selector: '.faq-item__toggle',
    handler(element) {
      element.closest('.faq-item').classList.toggle('is-open');
    },
  },
  {
    selector: '.form-checkbox__fauxbox span',
    handler(element) {
      element.parentNode.querySelector('[type="checkbox"]').click();
    },
  },
  {
    selector: '[data-close-flash]',
    handler(closeButton) {
      const flashType = closeButton.dataset['close-flash'];
      const flashMessage = closeButton.closest('.auth-flash-msg');

      flashMessage.classList.add('hide');
      flashMessage.classList.remove('auth-flash-msg--' + flashType);
      flashMessage.querySelector('span').innerHTML = '';
    },
  },
];

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const element = event.target;
    for (const clickHandler of documentClickHandlers) {
      const target = element.closest(clickHandler.selector);
      if (target === null) {
        continue;
      }
      event.preventDefault();
      clickHandler.handler(target);
    }
  });
});
